var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.66 18.592a.6.6 0 0 1 0 1.199h-.01a.6.6 0 1 1 0-1.2zm18.69 0a.6.6 0 1 1 0 1.199H7.844a.6.6 0 1 1 0-1.2zM2.66 11.319a.6.6 0 0 1 0 1.2h-.01a.6.6 0 1 1 0-1.2zm18.69 0a.6.6 0 1 1 0 1.2H7.844a.6.6 0 1 1 0-1.2zM2.66 4.047a.6.6 0 0 1 0 1.2h-.01a.6.6 0 1 1 0-1.2zm18.69 0a.6.6 0 1 1 0 1.2H7.844a.6.6 0 1 1 0-1.2z"
  })));
};
export default SvgList;